import { render, staticRenderFns } from "./PedidoV.vue?vue&type=template&id=7249efe7"
import script from "./PedidoV.vue?vue&type=script&lang=js"
export * from "./PedidoV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports